import { call, getContext, put, takeLatest } from 'redux-saga/effects';
import BasketAPI from '../../../api/basket/BasketAPI';
import { basketActions } from '../actions/BasketActions.creators';
import { BasketActionTypes } from '../../../enums/ActionEnums';
export function* basketOverviewAnalytics() {
    try {
        const { servicesEndpoint, defaultRequestParams } = yield getContext('aemConfiguration');
        const analyticsAdobeTagManagerData = yield call(BasketAPI.basketOverviewDtm, servicesEndpoint, defaultRequestParams);
        yield put(basketActions.createBasketOverviewAdobeAnalyticsSuccessAction(analyticsAdobeTagManagerData));
    }
    catch (_a) { }
}
export function* basketOverviewAnalyticsSaga() {
    yield takeLatest(BasketActionTypes.BASKET_OVERVIEW_INIT, basketOverviewAnalytics);
}
